import Util from '@/lib/util'
export default [
    {
        title: Util.L('Action'),
        slot: 'action',
        align: 'center',
        width: 100
    }]
